import { getUserListAPI } from "@/apis/admin-api"
import { create } from "zustand"
import { createListStore } from "../create-list-store-util"

export const userStore = create(createListStore(getUserListAPI))
